var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"address__custom__row",class:{
    center: _vm.center,
    'button-row': _vm.button,
    mobile: _vm.mobile
  },on:{"click":_vm.handleClick}},[(_vm.icon)?_c('div',{staticClass:"address__custom__row-icon"},[_c('SvgIcon',{attrs:{"width":"24","height":"24","icon":_vm.iconName}})],1):_vm._e(),_c('div',{domProps:{"innerHTML":_vm._s(_vm.text)}})])}
var staticRenderFns = []

export { render, staticRenderFns }